import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import {savaScore} from "@/servers/storeManageApi";
import './index.scss'
import {Button, Modal, Input, message} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../servers/menuAPI";
import store from "../../../../redux";
import { getStorage} from "@/utils";
import {refreshMenu} from "../../../../redux/common/action";
import CInput from '@/components/CForm/CInput'
import CRadio from '@/components/CForm/CRadio'

@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangetext = this.onChangetext.bind(this);
  }


  state = {
    data: [],
    tips:'',
    searchData: {
      value: '',//搜索框筛选
      placeholder: '请输入评分'
    },
    isModalVisible:false,
    previewImage:'',
    options:[
      {
        value:1,name:'是'
      },
      {
        value:0,name:'否'
      },
    ],
    select:'',
    suggest:''
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

  onSubmit(){
    if (this.state.suggest.length > 200) {
      message.error('本年度综合建议字数在200字以内');
      return false
    }
    const params = [{
      score: this.state.select,
      id:this.state.id,
      notes: this.state.suggest
    }]
    savaScore(params).then(res=>{
      if(res.statecode === 0) {
        this.props.refreshMenu(true)
        message.success('保存成功');
        // this.props.history.push({
        //   pathname: '/homeScore',
        // });
      } else {
        message.error(res.statemessage);
      }
    })
  }

  onChange(value) {
    this.setState({
      select:value
    })
  }

  onChangetext(data){
    // if (data.length > 200) {
    //   message.error('本年度综合建议字数在200字以内');
    //   return false
    // }
    this.setState({
      suggest:data
    })
  }

  onSelect(){
    const params = {
      annual:getStorage('year'),
      indid:'4.3',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      this.setState({
        id:res.records[0].id,
        suggest:decodeURIComponent(res.records[0].notes),
        select: Number(res.records[0].score)
      })
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          <div className="import">
            <h3 style={{fontSize:'18px'}}>本年度综合建议（200字以内）</h3>
            <CInput type='textarea'
                    value={this.state.suggest}
                    onChange={this.onChangetext}
            />
            <div style={{marginTop:'20px'}}>
              <span style={{marginRight:'10px'}}>是否建议现场核查</span>
              <CRadio
                  value={this.state.select}
                  options={this.state.options}
                  onChange={this.onChange}
              />
            </div>
          </div>
          <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
            <Button type="primary" className='yl' onClick={this.onSubmit}>保存</Button>
          </div>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
